import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Box } from '@mui/material';

import { LozengeSelectFilter } from '../Filter/LozengeSelectFilter';
import { usePoiFilterOptions } from '../../map-data/use-filter-options';
import { theme } from '../../styles/theme';
import { hexToRgb } from '../../utils/colour-utils';
import type { MultiChoiceToggleFilterConfig } from '../Filter/filter-types';

export const PoiMapFilters: FC = () => {
  const { t } = useTranslation();
  const { updateFilterOptions, filterOptions } = usePoiFilterOptions();

  const designFilterConfig: MultiChoiceToggleFilterConfig = {
    icon: 'StudyDesignCheck',
    title: '',
    key: 'design',
    subtitle: '',
    width: 'full',
    keyOptions: [
      {
        label: t('pinMap.studyDesigns.seeAll'),
        value: 'SeeAllDesigns',
        color: '255, 255, 255',
        textColor: '#000000',
      },
      {
        value: 'Clinical trial',
        label: t('pinMap.studyDesigns.clinicalTrial'),
        color: hexToRgb(theme.colors['blue-study']),
      },
      {
        value: 'Implementation study',
        label: t('pinMap.studyDesigns.implementationStudy'),
        color: hexToRgb(theme.colors['pale-orange']),
      },
      {
        value: 'Regional programme',
        label: t('pinMap.studyDesigns.regionalProgramme'),
        color: hexToRgb(theme.colors['yellow-100']),
      },
      {
        value: 'National programme',
        label: t('pinMap.studyDesigns.nationalProgramme'),
        color: hexToRgb(theme.colors['green-100']),
      },
    ],
    onUpdate: updateFilterOptions,
    filterType: 'multiChoiceToggle',
  };

  // Get the current design filter value
  const currentDesign = filterOptions.design;
  const selectedValues = Array.isArray(currentDesign) ? currentDesign : [];

  return (
    <Box
      sx={{
        position: 'absolute',
        top: 8,
        left: 8,
        right: 8,
        display: 'flex',
        gap: 1,
        zIndex: 1,
      }}
    >
      <LozengeSelectFilter
        filterConfig={designFilterConfig}
        selectedValues={selectedValues}
        isMultiSelect={true}
        useOutlineStyle={true}
        compactMode={true}
        clearValue="SeeAllDesigns"
      />
    </Box>
  );
};
